/// <amd-module name="TFS/Security/Common/Util" />
import { ResourceSecurityComponent } from "TFS/Admin/Common/Constants/TelemetryConstants";
import { Feature } from "TFS/Admin/Common/Constants/TelemetryConstants";
import { AdminFeatureTelemetryLogger } from "TFS/Admin/Common/Util/Telemetry/AdminTelemetry";
import { IVssPageContext } from "VSS/Platform/Context";

export function logTelemetry(
    pageContext: IVssPageContext,
    permissionSetId: string,
    component: ResourceSecurityComponent,
    action: string,
    properties?: { [key: string]: any }
): AdminFeatureTelemetryLogger {
    const telemetryLogger: AdminFeatureTelemetryLogger = new AdminFeatureTelemetryLogger(
        pageContext,
        Feature.ResourceSecurity,
        ResourceSecurityComponent[component],
        action
    );

    const propertiesObj = properties ? properties : {};
    propertiesObj.permissionsSetId = permissionSetId;

    telemetryLogger.captureTelemetry(propertiesObj);

    return telemetryLogger;
}
